import { RootState } from "@app/redux/root-reducer";

export const selectCarTypeState = (store: RootState) =>
  store.carTypesReducer.dashboard;

export const selectNonParentCategories = (store: RootState) =>
  store.carTypesReducer.nonParentCategories;
